import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { RepoUrlSelector } from './components/RepoUrlSelector/RepoUrlSelector.esm.js';
import { ResourcePicker } from './components/ResourcePicker/ResourcePicker.esm.js';
import { UploadFilePicker } from './components/UploadFilePicker/UploadFIlePicker.esm.js';
import { OptionsPickerSchema } from './components/OptionsPicker/schema.esm.js';
import { OptionsPicker } from './components/OptionsPicker/OptionsPicker.esm.js';
import { RepoUrlSelectorSchema } from './components/RepoUrlSelector/schema.esm.js';
import { ResourcePickerSchema } from './components/ResourcePicker/schema.esm.js';
import { UploadFilePickerSchema } from './components/UploadFilePicker/schema.esm.js';

const RepoUrlSelectorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "RepoUrlSelector",
    component: RepoUrlSelector,
    schema: RepoUrlSelectorSchema
  })
);
const ResourcePickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "ResourcePicker",
    component: ResourcePicker,
    schema: ResourcePickerSchema
  })
);
const UploadFilePickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "UploadFilePicker",
    component: UploadFilePicker,
    schema: UploadFilePickerSchema
  })
);
const OptionsPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "OptionsPicker",
    component: OptionsPicker,
    schema: OptionsPickerSchema
  })
);

export { OptionsPickerExtension, RepoUrlSelectorExtension, ResourcePickerExtension, UploadFilePickerExtension };
//# sourceMappingURL=plugin.esm.js.map
